export const spinDelay = 300;
export const notificationInterval = 5 * 60 * 1000;

export const defaultPagination = {
    page: 1,
    line: 0,
    linesPerPage: 20
};
